export function formatManagementDisplay(management: string | undefined | null): string {
  if (!management || management.toUpperCase() === 'DISCOVERED') {
    return 'Unmanaged';
  }
  return management[0].toUpperCase() + management.slice(1).toLowerCase();
}
